import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '../../../../../../components/mui/Core/index'
import Constants from '../../../../../../constants/en.json'
import { useTheme } from '../../../../../../components/mui/Styles/index'
import { setSelectedRole } from '../../update-user-role-slice'

function SelectRoleForUpdate({ selectedUser }) {
  const theme = useTheme()
  const dispatch = useDispatch()
  const roles = useSelector((state) => state.userManagement.roles)
  const currentApp = selectedUser?.appName
  const currentAppRoles = roles?.filter((role) => role?.appName === currentApp)
  const selectedRole = useSelector((state) => state.updateUserRole?.selectedRole)

  const rootStyle = { minHeight: '150px' }
  const roleSectionStyle = { marginTop: '20px' }
  const roleInputLabelStyle = {
    marginTop: '8px',
    '&.MuiInputLabel-root.Mui-focused': {
      color: theme.palette.secondary.main,
    },
  }
  const selectRoleContainerStyle = { marginTop: '8px' }
  const roleSelectStyle = {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.secondary.main,
    },
  }
  const selectRoleMenuProps = {
    PaperProps: {
      sx: {
        maxHeight: 250,
        overflowY: 'auto',
      },
    },
  }

  const handleSelectRole = (event) => {
    dispatch(setSelectedRole(event.target.value))
  }

  return (
    <Box sx={rootStyle}>
      <Box>
        <Typography variant='cardHeader'>
          {Constants.userManagement.updateRole.UPDATE_ROLE}
        </Typography>
      </Box>
      <Box sx={roleSectionStyle}>
        <Box>
          <Typography variant='cardMessage'>
            {`${Constants.userManagement.updateRole.USER_ROLE}`}
          </Typography>
        </Box>
        <Box>
          <FormControl fullWidth>
            <InputLabel sx={roleInputLabelStyle}>
              {Constants.userManagement.updateRole.ROLE}
            </InputLabel>
            <Box sx={selectRoleContainerStyle}>
              <Select
                sx={roleSelectStyle}
                fullWidth
                value={selectedRole || selectedUser?.role || ''}
                onChange={handleSelectRole}
                MenuProps={selectRoleMenuProps}
              >
                {currentAppRoles?.map((item) => {
                  return (
                    <MenuItem key={item.roleName} value={item?.roleDescription}>
                      {item.roleDescription}
                    </MenuItem>
                  )
                })}
              </Select>
            </Box>
          </FormControl>
        </Box>
      </Box>
    </Box>
  )
}

SelectRoleForUpdate.propTypes = {
  selectedUser: PropTypes.oneOfType([
    PropTypes.shape({
      role: PropTypes.string.isRequired,
    }),
    PropTypes.oneOf([null]),
  ]),
}

export default SelectRoleForUpdate
